import { ReactSVG } from 'react-svg';

import SetSupplier from 'routes/set-supplier/SetSupplier';
import styles from './PrivateLayoutSidebar.module.scss';

function PrivateLayoutSidebar({ menu }: { menu: JSX.Element }) {
    return (
        <aside className={styles.sidebar}>
            <ReactSVG
                src="/assets/images/svgs/logo.svg"
                className={styles.logo}
            />
            <div className={styles.menu}>{menu}</div>

            <div className={styles.suppliers}>
                <div className={styles.seperator_line}></div>
                <SetSupplier/>
            </div>
        </aside>
    );
}

export default PrivateLayoutSidebar;
